import { Meshes_FieldDataArrayNames, Meshes_PointDataArrayNames } from "../Common/CommonBindings.js";
import { Common_floatToMm, Visualization_UnifiedTransitionBranch_get_toDistance, Visualization_UnifiedBranch, Visualization_UnifiedTransitionBranch } from "../../RAWMap.Models/Common.js";
import { CenterlineVolumeModule_calculateVolume, DiameterRangeViewModel, CenterlineMeasurementValueViewModel, LocalDiameterViewModel, StentPlanningDiametersViewModel, UnifiedBranchRangeSelectionViewModel$1, Bindings_PlaneIdentifier, CenterlineMeasurementValueViewModelModule_$007CDistanceRangeBranch$007CTransitionRangeBranch$007CPointBranch$007CVolumeBranch$007C, UnifiedTransitionBranchPointSelectionViewModel } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { toArray, exists, empty, singleton, ofArray, map } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { CenterlinePlaneRange, CenterlinePlane } from "./CenterlineMeasurementBindings.js";
import { Optic_Set, Optic_Set_op_HatEquals_2170E4F5, Optic_Get, Optic_Get_op_HatDot_21762A61 } from "../../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { ofList, FSharpMap__get_Item } from "../../fable_modules/fable-library-js.4.19.3/Map.js";
import { curry2, comparePrimitives, equals, stringHash, compare } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { append, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { Array_distinctBy } from "../../fable_modules/fable-library-js.4.19.3/Seq2.js";
import { some, map as map_1, defaultArgWith } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { append as append_1, map as map_2, maxBy, minBy, item, tryFind } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { max } from "../../fable_modules/fable-library-js.4.19.3/Double.js";
import { setCenterlinePlaneRange, setCenterlinePlanes } from "../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneHooks.js";

export const ArrayNames_pointDataArrayNames = new Meshes_PointDataArrayNames("Maximum_Diameters", "Minimum_Diameters", "Equivalent_Circle_Diameter", "Stent_Planning_Diameters", "Normals", "Volume", "Distances", "Z_Dimension", "Z_Position");

export const ArrayNames_fieldDataArrayNames = new Meshes_FieldDataArrayNames("Transition_Branch_Trunk", "Transition_Branch_Left", "Transition_Branch_Right", "Transition_Volume", "Distance_Branch_Trunk", "Distance_Branch_Left", "Distance_Branch_Right", "Distance_Branch_Trunk_Cusp");

export const UnifiedBranchPointSelectionViewModel_defaultBranchSelection = new UnifiedTransitionBranchPointSelectionViewModel(new Visualization_UnifiedTransitionBranch(0, []), 0);

export function CenterlineMeasurementViewModel_toCenterlinePlanes(callbackIdentifier, centerline, vm) {
    const mkCenterlinePlanes = (branch, planeIdentifiers, indexLookup, branchSelection) => map((planeIdentifier_1) => (new CenterlinePlane(centerline, branch, indexLookup(branchSelection)(planeIdentifier_1), callbackIdentifier, planeIdentifier_1)), planeIdentifiers);
    const activePatternResult = CenterlineMeasurementValueViewModelModule_$007CDistanceRangeBranch$007CTransitionRangeBranch$007CPointBranch$007CVolumeBranch$007C(vm);
    switch (activePatternResult.tag) {
        case 1:
            return mkCenterlinePlanes(new Visualization_UnifiedBranch(1, [activePatternResult.fields[0].branch]), ofArray([new Bindings_PlaneIdentifier(0, []), new Bindings_PlaneIdentifier(1, [])]), (rangeSelection_3) => ((planeId_1) => Optic_Get_op_HatDot_21762A61(new Optic_Get(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_3) => vm_3.firstIndex, (v_2) => ((vm_1_3) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_3.branch, v_2, vm_1_3.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_4) => vm_4.secondIndex, (v_3) => ((vm_1_4) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_4.branch, vm_1_4.firstIndex, v_3)))]]]), {
                Compare: compare,
            }), planeId_1))(rangeSelection_3)), activePatternResult.fields[0]);
        case 2:
            return mkCenterlinePlanes(new Visualization_UnifiedBranch(0, [Visualization_UnifiedTransitionBranch_get_toDistance()(activePatternResult.fields[0].branch)]), singleton(new Bindings_PlaneIdentifier(0, [])), (pointSelection_1) => ((_arg) => pointSelection_1.index), activePatternResult.fields[0]);
        case 3: {
            const rangePlanes = mkCenterlinePlanes(new Visualization_UnifiedBranch(1, [activePatternResult.fields[0][0].branch]), ofArray([new Bindings_PlaneIdentifier(0, []), new Bindings_PlaneIdentifier(1, [])]), (rangeSelection_5) => ((planeId_2) => Optic_Get_op_HatDot_21762A61(new Optic_Get(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_5) => vm_5.firstIndex, (v_4) => ((vm_1_5) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_5.branch, v_4, vm_1_5.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_6) => vm_6.secondIndex, (v_5) => ((vm_1_6) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_6.branch, vm_1_6.firstIndex, v_5)))]]]), {
                Compare: compare,
            }), planeId_2))(rangeSelection_5)), activePatternResult.fields[0][0]);
            let pointPlanes;
            if (activePatternResult.fields[0][1] == null) {
                pointPlanes = empty();
            }
            else {
                const pointSelection_2 = activePatternResult.fields[0][1];
                pointPlanes = mkCenterlinePlanes(new Visualization_UnifiedBranch(1, [pointSelection_2.branch]), singleton(new Bindings_PlaneIdentifier(2, [])), (pointSelection_3) => ((_arg_1) => pointSelection_3.index), pointSelection_2);
            }
            return toList(delay(() => append(rangePlanes, delay(() => pointPlanes))));
        }
        default:
            return mkCenterlinePlanes(new Visualization_UnifiedBranch(0, [activePatternResult.fields[0].branch]), ofArray([new Bindings_PlaneIdentifier(0, []), new Bindings_PlaneIdentifier(1, [])]), (rangeSelection_1) => ((planeId) => Optic_Get_op_HatDot_21762A61(new Optic_Get(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_1) => vm_1.firstIndex, (v) => ((vm_1_1) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_1.branch, v, vm_1_1.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_2) => vm_2.secondIndex, (v_1) => ((vm_1_2) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_2.branch, vm_1_2.firstIndex, v_1)))]]]), {
                Compare: compare,
            }), planeId))(rangeSelection_1)), activePatternResult.fields[0]);
    }
}

function CenterlineMeasurementViewModel_verifySameCallbackIdentifier(measurements) {
    let array_1;
    if (((array_1 = Array_distinctBy((m) => m.callbackIdentifier, measurements, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), array_1.length)) !== 1) {
        throw new Error("measurements must contain the same callbackIdentifier\\nParameter name: measurements");
    }
}

function CenterlineMeasurementViewModel_validateIndexes(measurements) {
    if (measurements.some((m) => {
        if (m.index < 0) {
            return true;
        }
        else {
            return m.index >= m.numberOfPoints;
        }
    })) {
        throw new Error("index must be positive and less than numberOfPoints\\nParameter name: measurements");
    }
}

function CenterlineMeasurementViewModel_getIndexForPlane(planeIdentifier, measurements) {
    return defaultArgWith(map_1((m_1) => m_1.index, tryFind((m) => equals(m.planeIdentifier, planeIdentifier), measurements)), () => {
        throw new Error((toText(printf("measurements must contain an entry for planeIdentifier %O"))(planeIdentifier) + "\\nParameter name: ") + "measurements");
    });
}

function CenterlineMeasurementViewModel_mkBranchPointSelection(planeIdentifier, pointSelection, measurements) {
    return new UnifiedTransitionBranchPointSelectionViewModel(pointSelection.branch, CenterlineMeasurementViewModel_getIndexForPlane(planeIdentifier, measurements));
}

export function CenterlineMeasurementViewModel_ofCenterlinePointMeasurements(measurements, existingVm) {
    let measurements_1;
    switch (existingVm.tag) {
        case 2: {
            if (measurements.length !== 1) {
                throw new Error("measurements must contain exactly 1 element\\nParameter name: measurements");
            }
            CenterlineMeasurementViewModel_verifySameCallbackIdentifier(measurements);
            CenterlineMeasurementViewModel_validateIndexes(measurements);
            return new CenterlineMeasurementValueViewModel(2, [[CenterlineMeasurementViewModel_mkBranchPointSelection(new Bindings_PlaneIdentifier(0, []), existingVm.fields[0][0], measurements), new LocalDiameterViewModel(Common_floatToMm(item(0, measurements).secondaryDiameter), Common_floatToMm(item(0, measurements).maxDiameter), Common_floatToMm(item(0, measurements).circleEquivalentDiameter), new StentPlanningDiametersViewModel(Common_floatToMm(item(0, measurements).stentPlanningMin), Common_floatToMm(item(0, measurements).stentPlanningMax), Common_floatToMm(item(0, measurements).stentPlanningAverage)))]]);
        }
        case 1:
            throw new Error("value cannot be DiameterRange\\nParameter name: existingVm");
        case 3:
            throw new Error("value cannot be CenterlineVolume\\nParameter name: existingVm");
        default: {
            if (measurements.length !== 2) {
                throw new Error("measurements must contain exactly 2 elements\\nParameter name: measurements");
            }
            CenterlineMeasurementViewModel_verifySameCallbackIdentifier(measurements);
            CenterlineMeasurementViewModel_validateIndexes(measurements);
            return new CenterlineMeasurementValueViewModel(0, [[(measurements_1 = measurements, new UnifiedBranchRangeSelectionViewModel$1(existingVm.fields[0][0].branch, CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(0, []), measurements_1), CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(1, []), measurements_1))), Common_floatToMm(Math.abs(item(1, measurements).distance - item(0, measurements).distance))]]);
        }
    }
}

export function CenterlineMeasurementViewModel_ofDiameterRange(planeCpms, measurements, existingVm) {
    if (existingVm.tag === 1) {
        if (measurements.length === 0) {
            throw new Error("measurements must not be empty\\nParameter name: measurements");
        }
        CenterlineMeasurementViewModel_verifySameCallbackIdentifier(planeCpms);
        CenterlineMeasurementViewModel_validateIndexes(planeCpms);
        let branchSelection;
        const measurements_1 = planeCpms;
        branchSelection = (new UnifiedBranchRangeSelectionViewModel$1(existingVm.fields[0][0].branch, CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(0, []), measurements_1), CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(1, []), measurements_1)));
        const minCpm = minBy((m) => m.secondaryDiameter, measurements, {
            Compare: comparePrimitives,
        });
        const maxCpm = maxBy((m_1) => m_1.maxDiameter, measurements, {
            Compare: comparePrimitives,
        });
        return new CenterlineMeasurementValueViewModel(1, [[branchSelection, new DiameterRangeViewModel(Common_floatToMm(minCpm.secondaryDiameter), Common_floatToMm(maxCpm.maxDiameter))]]);
    }
    else {
        throw new Error("value must be DiameterRange\\nParameter name: existingVm");
    }
}

export function CenterlineMeasurementViewModel_ofCenterlineVolume(bounds, measurements, existingVm) {
    let measurements_1;
    if (existingVm.tag === 3) {
        const rangeSelection = existingVm.fields[0][0];
        if ((measurements.length < 2) ? true : (measurements.length > 3)) {
            throw new Error("measurements must contain 2 or 3 elements\\nParameter name: measurements");
        }
        CenterlineMeasurementViewModel_verifySameCallbackIdentifier(measurements);
        CenterlineMeasurementViewModel_validateIndexes(measurements);
        return new CenterlineMeasurementValueViewModel(3, [[(measurements_1 = measurements, new UnifiedBranchRangeSelectionViewModel$1(rangeSelection.branch, CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(0, []), measurements_1), CenterlineMeasurementViewModel_getIndexForPlane(new Bindings_PlaneIdentifier(1, []), measurements_1))), map_1((pointSelection) => CenterlineMeasurementViewModel_mkBranchPointSelection(new Bindings_PlaneIdentifier(2, []), pointSelection, measurements), existingVm.fields[0][1]), CenterlineVolumeModule_calculateVolume(rangeSelection, bounds, measurements)]]);
    }
    else {
        throw new Error("value must be CenterlineVolume\\nParameter name: existingVm");
    }
}

export function updatePlaneIndex(branchIndexBounds, planeIdentifier, index, vm) {
    let branch, validBounds;
    const isValueWithinBounds = (value, bounds) => {
        if (value >= bounds.firstIndex) {
            return value <= bounds.lastIndex;
        }
        else {
            return false;
        }
    };
    const isValidDiameterIndex = (branch_1) => {
        const validBounds_1 = (branch_1.tag === 1) ? ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceRightBranch]) : ((branch_1.tag === 2) ? ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceTrunkCusp]) : ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceLeftBranch]));
        return exists(curry2(isValueWithinBounds)(index), validBounds_1);
    };
    const updateIfValid = (isValid, updateValue, currentValue) => {
        if (isValid) {
            return updateValue();
        }
        else {
            return currentValue;
        }
    };
    switch (vm.tag) {
        case 1: {
            const tupledArg_1 = [vm.fields[0][0], vm.fields[0][1]];
            const rangeSelectionVm_2 = tupledArg_1[0];
            return updateIfValid(isValidDiameterIndex(rangeSelectionVm_2.branch), () => (new CenterlineMeasurementValueViewModel(1, [[Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_3) => vm_3.firstIndex, (v_2) => ((vm_1_3) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_3.branch, v_2, vm_1_3.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_4) => vm_4.secondIndex, (v_3) => ((vm_1_4) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_4.branch, vm_1_4.firstIndex, v_3)))]]]), {
                Compare: compare,
            }), planeIdentifier))(index)(rangeSelectionVm_2), tupledArg_1[1]]])), vm);
        }
        case 2: {
            const tupledArg_2 = [vm.fields[0][0], vm.fields[0][1]];
            const pointSelectionVm = tupledArg_2[0];
            return updateIfValid(isValidDiameterIndex(pointSelectionVm.branch), () => (new CenterlineMeasurementValueViewModel(2, [[new UnifiedTransitionBranchPointSelectionViewModel(pointSelectionVm.branch, index), tupledArg_2[1]]])), vm);
        }
        case 3: {
            const tupledArg_3 = [vm.fields[0][0], vm.fields[0][1], vm.fields[0][2]];
            const currentValue_4 = vm;
            const rangeSelectionVm_4 = tupledArg_3[0];
            const maybePointSelectionVm = tupledArg_3[1];
            const volume = tupledArg_3[2];
            const lastTrunkIndex = branchIndexBounds.transitionTrunk.lastIndex | 0;
            let matchResult;
            switch (planeIdentifier.tag) {
                case 2: {
                    if (maybePointSelectionVm == null) {
                        matchResult = 2;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                default:
                    matchResult = 0;
            }
            switch (matchResult) {
                case 0: {
                    const isAtLeastOnePlaneOnTrunk = (planeIdentifier.tag === 0) ? (!((index > lastTrunkIndex) && (rangeSelectionVm_4.secondIndex > lastTrunkIndex))) : ((planeIdentifier.tag === 1) ? (!((index > lastTrunkIndex) && (rangeSelectionVm_4.firstIndex > lastTrunkIndex))) : true);
                    const isValueWithinValidBounds = (value_3) => exists(curry2(isValueWithinBounds)(value_3), ofArray([branchIndexBounds.transitionTrunk, branchIndexBounds.transitionLeftBranch]));
                    const isIndexWithinBounds = isValueWithinValidBounds(index);
                    const isCurrentRangeSelectionValid = (!((rangeSelectionVm_4.firstIndex > lastTrunkIndex) && (rangeSelectionVm_4.secondIndex > lastTrunkIndex)) && isValueWithinValidBounds(rangeSelectionVm_4.firstIndex)) && isValueWithinValidBounds(rangeSelectionVm_4.secondIndex);
                    const updateSelectionsWithIndex = (idx_2) => {
                        let updatedRangeSelection;
                        const updatedRangeSelection_1 = ((vm_5) => Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_6) => vm_6.firstIndex, (v_4) => ((vm_1_5) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_5.branch, v_4, vm_1_5.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_7) => vm_7.secondIndex, (v_5) => ((vm_1_6) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_6.branch, vm_1_6.firstIndex, v_5)))]]]), {
                            Compare: compare,
                        }), planeIdentifier))(idx_2)(vm_5))(rangeSelectionVm_4);
                        return new CenterlineMeasurementValueViewModel(3, [[updatedRangeSelection_1, (updatedRangeSelection = updatedRangeSelection_1, (maybePointSelectionVm != null) ? (((updatedRangeSelection.firstIndex <= lastTrunkIndex) && (updatedRangeSelection.secondIndex <= lastTrunkIndex)) ? undefined : maybePointSelectionVm) : ((index > lastTrunkIndex) ? (new UnifiedTransitionBranchPointSelectionViewModel(new Visualization_UnifiedTransitionBranch(1, []), lastTrunkIndex + 1)) : maybePointSelectionVm)), volume]]);
                    };
                    if ((isAtLeastOnePlaneOnTrunk && isIndexWithinBounds) && isCurrentRangeSelectionValid) {
                        return updateSelectionsWithIndex(index);
                    }
                    else if (!isAtLeastOnePlaneOnTrunk && !isCurrentRangeSelectionValid) {
                        return updateSelectionsWithIndex(lastTrunkIndex);
                    }
                    else if ((isAtLeastOnePlaneOnTrunk && !isIndexWithinBounds) && !isCurrentRangeSelectionValid) {
                        return updateSelectionsWithIndex(branchIndexBounds.transitionLeftBranch.lastIndex);
                    }
                    else {
                        return currentValue_4;
                    }
                }
                case 1: {
                    const pointSelectionVm_1 = maybePointSelectionVm;
                    if (isValueWithinBounds(index, branchIndexBounds.transitionRightBranch)) {
                        return new CenterlineMeasurementValueViewModel(3, [[rangeSelectionVm_4, new UnifiedTransitionBranchPointSelectionViewModel(pointSelectionVm_1.branch, max(lastTrunkIndex + 1, index)), volume]]);
                    }
                    else {
                        return currentValue_4;
                    }
                }
                default: {
                    console.warn(some("Attempted to move third plane when it doesn\'t exist"));
                    return currentValue_4;
                }
            }
        }
        default: {
            const tupledArg = [vm.fields[0][0], vm.fields[0][1]];
            const rangeSelectionVm = tupledArg[0];
            return updateIfValid((branch = rangeSelectionVm.branch, (validBounds = ((branch.tag === 1) ? ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceRightBranch]) : ((branch.tag === 2) ? singleton(branchIndexBounds.distanceTrunkCusp) : ofArray([branchIndexBounds.distanceTrunk, branchIndexBounds.distanceLeftBranch]))), exists(curry2(isValueWithinBounds)(index), validBounds))), () => (new CenterlineMeasurementValueViewModel(0, [[Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), FSharpMap__get_Item(ofList(ofArray([[new Bindings_PlaneIdentifier(0, []), [(vm_1) => vm_1.firstIndex, (v) => ((vm_1_1) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_1.branch, v, vm_1_1.secondIndex)))]], [new Bindings_PlaneIdentifier(1, []), [(vm_2) => vm_2.secondIndex, (v_1) => ((vm_1_2) => (new UnifiedBranchRangeSelectionViewModel$1(vm_1_2.branch, vm_1_2.firstIndex, v_1)))]]]), {
                Compare: compare,
            }), planeIdentifier))(index)(rangeSelectionVm), tupledArg[1]]])), vm);
        }
    }
}

export function Helpers_addOrUpdateMeasurements(centerlinePointMeasurements, measurement) {
    if (centerlinePointMeasurements.some((c) => equals(c.planeIdentifier, measurement.planeIdentifier))) {
        return map_2((existingMeasurement) => {
            if (equals(existingMeasurement.planeIdentifier, measurement.planeIdentifier)) {
                return measurement;
            }
            else {
                return existingMeasurement;
            }
        }, centerlinePointMeasurements);
    }
    else {
        return append_1([measurement], centerlinePointMeasurements);
    }
}

export function Helpers_recomputeViewmodel(updatedMeasurements, targetVm, callbackId, centerline, updater, updateVM, getCenterlineBounds, defaultReturn_, defaultReturn__1) {
    const mkPlanes = (cvm) => toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(callbackId, centerline, cvm));
    const matchValue = updatedMeasurements.length | 0;
    let matchResult, cvm_1, cvm_2, cvm_3;
    if (targetVm == null) {
        matchResult = 3;
    }
    else {
        switch (targetVm.tag) {
            case 2: {
                if (matchValue === 1) {
                    matchResult = 0;
                    cvm_1 = targetVm;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 1: {
                if (matchValue === 2) {
                    matchResult = 1;
                    cvm_2 = targetVm;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 3: {
                if (targetVm.fields[0][1] != null) {
                    if (matchValue === 3) {
                        matchResult = 2;
                        cvm_3 = targetVm;
                    }
                    else {
                        matchResult = 3;
                    }
                }
                else if (matchValue === 2) {
                    matchResult = 2;
                    cvm_3 = targetVm;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            default:
                if (matchValue === 2) {
                    matchResult = 0;
                    cvm_1 = targetVm;
                }
                else {
                    matchResult = 3;
                }
        }
    }
    switch (matchResult) {
        case 0:
            return [updateVM(CenterlineMeasurementViewModel_ofCenterlinePointMeasurements(updatedMeasurements, cvm_1)), setCenterlinePlanes(updater, mkPlanes(cvm_1))];
        case 1: {
            const planes_1 = mkPlanes(cvm_2);
            const rangeResult = setCenterlinePlaneRange(updater, new CenterlinePlaneRange(item(0, planes_1), item(1, planes_1)));
            return [updateVM(CenterlineMeasurementViewModel_ofDiameterRange(updatedMeasurements, rangeResult.rangeValues, cvm_2)), rangeResult.pipelines];
        }
        case 2:
            return [updateVM(CenterlineMeasurementViewModel_ofCenterlineVolume(getCenterlineBounds(), updatedMeasurements, cvm_3)), setCenterlinePlanes(updater, mkPlanes(cvm_3))];
        default:
            return [defaultReturn_, defaultReturn__1];
    }
}

